import React from 'react';

function BattleSongCard({ song, submitter, votes, totalVotes, voted, isMyVote, onVote, disabled, presenter }) {
  const votePercent = totalVotes > 0 ? Math.round((votes / totalVotes) * 100) : 0;
  const showVotes = presenter || voted;

  return (
    <div className={`battle-song-card ${isMyVote ? 'selected' : ''} ${voted && !isMyVote && !presenter ? 'dimmed' : ''}`}>
      <div className="bsc-iframe-container">
        <iframe
          src={`https://open.spotify.com/embed/track/${song.id}?utm_source=generator&theme=0`}
          width="100%"
          height="100%"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          title={song.name}
          className="bsc-iframe"
          onClick={(e) => e.stopPropagation()}
        />
      </div>

      {submitter && (
        <div className="bsc-submitter-row">
          <div className="bsc-avatar">{submitter.charAt(0).toUpperCase()}</div>
          <span className="bsc-submitter-text">Eingereicht von <strong>{submitter}</strong></span>
        </div>
      )}

      <div className="bsc-divider" />

      {showVotes && (
        <div className="bsc-vote-bar-container">
          <div className="bsc-vote-bar" style={{ width: `${votePercent}%` }} />
          <span className="bsc-vote-bar-text">
            {votes} {votes === 1 ? 'Stimme' : 'Stimmen'} ({votePercent}%)
          </span>
        </div>
      )}

      {presenter ? (
        <div className="bsc-presenter-label">📺 Live-Ergebnis</div>
      ) : (
        <button
          className={`bsc-vote-btn ${isMyVote ? 'bsc-vote-btn-selected' : ''}`}
          onClick={onVote}
          disabled={disabled || voted}
        >
          {isMyVote ? '✓ AUSGEWÄHLT' : 'SONG AUSWÄHLEN'}
        </button>
      )}
    </div>
  );
}

export default BattleSongCard;
